module.exports = __webpack_public_path__ + "screenshot.c52e28c68bc041635df2d25a61f18b6e.png";